import { render, staticRenderFns } from "./OpenRulePopup.vue?vue&type=template&id=549840d0&scoped=true&"
import script from "./OpenRulePopup.vue?vue&type=script&lang=js&"
export * from "./OpenRulePopup.vue?vue&type=script&lang=js&"
import style0 from "./OpenRulePopup.vue?vue&type=style&index=0&id=549840d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549840d0",
  null
  
)

export default component.exports